import Flickity from 'flickity';
import 'flickity-fade';
import 'flickity-as-nav-for';
import 'flickity-imagesloaded';

export default class SliderNew {
  constructor(selector) {
    this.container = selector.jquery
      ? selector.get(0)
      : selector;
    this.slider = this.container.querySelector('.js-slider-box');
    this.slides = this.slider.querySelectorAll('.js-slider-item');
    this.nextButton = this.container.querySelector('.js-next');
    this.previousButton = this.container.querySelector('.js-previous');
    this.dots = this.container.querySelector('.js-dots');
    this.dotItemsList = document.createDocumentFragment().childNodes;
    this.isForseInit = this.container.dataset.forseInit || false;

    this.numOfVisibleSlides = 0;
    if (this.slides.length) {
      this.slideWidth = this.slides[0].offsetWidth;
      this.containerWidth = this.slider.offsetWidth;
      this.numOfVisibleSlides = Math.round(this.containerWidth / this.slideWidth);
    }

    // Инициализируем слайдер если всего слайдов больше, чем видимых
    if ((this.slides.length > this.numOfVisibleSlides) || this.isForseInit) {
      this.flickity = new Flickity(this.slider, this.getOptions());
      this.onSelect();
    } else {
      if (this.nextButton) {
        this.nextButton.style.display = 'none';
      }
      if (this.previousButton) {
        this.previousButton.style.display = 'none';
      }
      this.container.classList.add('_no-flickity');
      this.container.classList.remove('_loading');
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.next();
      });
    }

    if (this.previousButton) {
      this.previousButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.previous();
      });
    }

    if (this.dots && this.slides.length > 1) {
      this.setDots();

      this.dotItemsList.forEach((item, index) => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          this.setActiveDotItem(index);
          this.goDot(index);
        });
      });
    }
  }

  getOptions() {
    const options = {
      prevNextButtons: false,
      pageDots: false,
      freeScroll: true,
      contain: true,
      cellAlign: 'left',
      wrapAround: true,
      selectedAttraction: 0.1,
      friction: 0.5,
      asNavFor: '.js-slider-main',
      initialIndex: 0,
      groupCells: '105%',
      on: {
        ready: this.onReady(),
        change: (index) => {
          this.onChange(index);
        },
      },
    };

    // добавляем авто смену
    const autoPlay = this.container.dataset.autoPlay;
    if (typeof autoPlay !== 'undefined') {
      Object.assign(options, {
        autoPlay: 7500,
        pauseAutoPlayOnHover: false,
      });
    }

    // добавляем анимацию переключения fade
    const fade = this.container.dataset.fade;
    if (typeof fade !== 'undefined') {
      Object.assign(options, {
        fade: true,
      });
      options.freeScroll = false;
      options.wrapAround = false;
    }

    // убираем листание по-кругу
    const loopOff = this.container.dataset.loopOff;
    if (typeof loopOff !== 'undefined') {
      Object.assign(options, {
        wrapAround: false,
      });
    }

    // убираем freeScroll
    const freeScrollOff = this.container.dataset.freeScrollOff;
    if (typeof freeScrollOff !== 'undefined') {
      Object.assign(options, {
        freeScroll: false,
      });
    }

    // устанавливаем индекс активного слайда
    const initialIndex = this.container.dataset.initialIndex;
    if (typeof initialIndex !== 'undefined') {
      Object.assign(options, {
        initialIndex: Number(initialIndex),
      });
    }

    // добавляем ленивую подгрузку изображений
    const lazyLoadValue = this.container.dataset.lazyLoad;
    if (typeof lazyLoadValue !== 'undefined') {
      Object.assign(options, {
        lazyLoad: parseInt(lazyLoadValue, 10) || true,
      });
    }

    // устанавливаем количество пролистываемых за раз слайдов
    const groupCells = this.container.dataset.groupCells;
    if (typeof groupCells !== 'undefined') {
      Object.assign(options, {
        groupCells: parseInt(groupCells, 10) || true,
      });
    }

    // добавляем расчёт высоты слайдера после загрузки картинки (для responsive слайдеров с переменной высотой)
    const imagesLoaded = this.container.dataset.imagesLoaded;
    if (typeof imagesLoaded !== 'undefined') {
      Object.assign(options, {
        imagesLoaded: true,
      });
    }

    // добавляем adaptiveHeight для адаптивной высоты слайда
    const adaptiveHeight = this.container.dataset.adaptiveHeight;
    if (typeof adaptiveHeight !== 'undefined') {
      Object.assign(options, {
        adaptiveHeight: true,
      });
    }

    return options;
  }

  onReady() {
    this.container.classList.remove('_loading');
    if (this.nextButton) {
      this.nextButton.removeAttribute('disabled');
    }
    if (this.previousButton) {
      this.previousButton.removeAttribute('disabled');
    }
  }

  onSelect() {
    this.flickity.on('select', (index) => {
      if (this.dotItemsList.length) {
        this.setActiveDotItem(index);
      }
    });

    if (typeof this.container.dataset.hideArrowsOnEdges !== 'undefined') {
      if (this.previousButton || this.nextButton) {
        this.handleArrowsOnEdges();
      }
    }
  }

  onChange() {
    if (typeof this.container.dataset.hideArrowsOnEdges !== 'undefined') {
      if (this.previousButton || this.nextButton) {
        this.handleArrowsOnEdges();
      }
    }
  }

  next() {
    this.flickity.next(false, false);
  }

  previous() {
    this.flickity.previous(false, false);
  }

  goDot(index) {
    this.flickity.select(index, false, false);
  }

  destroy() {
    this.flickity.destroy();
  }

  resize() {
    if (this.flickity && this.flickity.resize) {
      this.flickity.resize();
    }
  }

  setActiveDotItem(index) {
    const className = '_active';
    this.dotItemsList.forEach((item) => {
      item.classList.remove(className);
    });

    this.dotItemsList[index].classList.add(className);
  }

  setDots() {
    const slides = this.slider.querySelectorAll('.js-slider-item');
    slides.forEach(() => {
      const dotItem = document.createElement('button');
      dotItem.setAttribute('type', 'button');
      dotItem.classList.add('bullets__item');
      dotItem.classList.add('js-dots-item');
      this.dots.appendChild(dotItem);
    });
    this.dotItemsList = this.dots.querySelectorAll('.js-dots-item');

    if (this.dotItemsList.length) {
      const options = this.getOptions();
      this.dotItemsList[options.initialIndex].classList.add('_active');
    }
  }

  handleArrowsOnEdges() {
    if (!this.flickity) {
      if (this.previousButton) {
        this.previousButton.style.display = 'none';
      }

      if (this.nextButton) {
        this.nextButton.style.display = 'none';
      }

      return;
    }

    if (this.previousButton) {
      if (this.flickity.selectedIndex === 0) {
        this.previousButton.style.display = 'none';
      } else {
        this.previousButton.style.display = 'block';
      }
    }

    if (this.nextButton) {
      if ((this.flickity.selectedIndex + 1) === this.flickity.slides.length) {
        this.nextButton.style.display = 'none';
      } else {
        this.nextButton.style.display = 'block';
      }
    }
  }
}
